import {remCalc} from '../../_utils'

export default {
    baseStyle: {
        container: {
            boxSizing: 'border-box',
            minWidth: remCalc(310),
            w: '100%',
            h: '100%',
            direction: 'column',
            justify: 'flex-end',
            align: 'center',
            p: {
                base: 'xsmall.base',
                sm: 'xsmall.base',
                md: 'xsmall-1.base',
                lg: 'xsmall-1.base',
            },
            gap: remCalc(8),
            color: 'text.inverse',
            fontWeight: 'bold',
            textStyle: 'body-medium',
            position: 'relative',
        },
        headerContainer: {
            p: {
                base: 'small-1.base',
                sm: 'small-1.base',
                md: 'xsmall-1.base',
                lg: 'xsmall-1.base',
            },
            w: '100%',
            h: 'auto',
            flexDir: 'column',
            gap: {
                base: 'xsmall.base',

                sm: 'xsmall.base',
                md: 'xsmall.lg',
                lg: 'xsmall.lg',
            },
            alignItems: 'flex-start',
            justifyContent: 'center',
            position: 'absolute',
            top: 0,
        },
        badgeContainer: {
            bg: 'background.neutral.blue',
            borderRadius: 'medium-1',
            p: remCalc(4),
            width: remCalc(44),
            height: remCalc(22),
            alignItems: 'center',
            justifyContent: 'center',
        },
        badge: {
            textStyle: 'body-xxsmall',
            fontWeight: 'bold',
        },
        textContainer: {
            flexDir: 'column',
            gap: 'xxsmall.base',
            alignItems: 'flex-start',
            justifyContent: 'center',
        },
        title: {
            textStyle: 'head-large',
            fontWeight: 'light',
            fontFamily: 'heading',
        },
        subtitle: {
            textStyle: 'body-large',
            fontWeight: 'regular',
            whiteSpace: 'wrap',
        },
        button: {
            whiteSpace: 'wrap',
            alignSelf: 'flex-start',
        },
        footerContainer: {
            bg: 'transparent',
            alignItems: 'center',
            justifyContent: 'flex-start',
        },
        footerInner: {
            justifyContent: 'flex-start',
            alignItems: 'center',
            gap: remCalc(16),
            bg: 'transparent',
        },
        footerItem: {
            flexDir: 'column',
            alignItems: 'flex-start',
            justifyContent: 'center',
            gap: {
                base: 'xxsmall.base',
                sm: 'xxsmall.base',
                md: 'xxsmall.lg',
                lg: 'xxsmall.lg',
            },
        },
        footerIcon: {
            width: remCalc(18),
            height: remCalc(18),
        },
        footerTextGroup: {
            flexDir: 'column',
            gap: remCalc(2),
            alignItems: 'flex-start',
        },
        footerTitle: {
            textStyle: 'body-small',
            fontWeight: 'medium',
        },
        footerSubtitle: {
            textStyle: 'body-small',
            fontWeight: 'regular',
        },
    },
}
